import styled from '@emotion/styled';

import { getColor } from '../UICommon';
import { TabletWidth } from '../../../global.style';

export const MobileOrderSummaryHeight = 75;

export const TogglePaymentSummaryWrapper = styled.div`
  display: none;

  @media (max-width: ${TabletWidth}px) {
    display: block;
    background-color: ${getColor('LIGHT_CREAM')};
    width: 100%;
    top: 0;
  }
`;

export const OrderSummary = styled.div`
  border-bottom: 1px solid ${getColor('GRAY_30')};
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: ${getColor('GRAY_50')};
  height: ${MobileOrderSummaryHeight}px;
`;

export const OrderSummaryTextCol = styled.div`
  display: flex;
  align-items: center;
`;

export const OrderSummaryText = styled.span`
  font-size: 14px;
`;

export const Chevron = styled.img``;

export const PaymentAmountCol = styled.div`
  color: ${getColor('GRAY_80')};
  text-align: right;
  font-size: 14px;
`;

export const OldPrice = styled.span`
  display: block;
  text-decoration: line-through;
`;

export const CurrentPrice = styled.span`
  display: block;
  font-size: 14;
`;

export const PaymentSummaryWrapper = styled.div<{ showChildren: boolean; withYearlySuggest: boolean }>`
  display: ${({ showChildren }) => (showChildren ? 'block' : 'none')};
  padding-bottom: ${({ withYearlySuggest, showChildren }) => (withYearlySuggest && showChildren ? '32' : '0')}px;
`;
